import styled from "styled-components"

const Spacer = styled.div`
  flex: 1 1 auto;
`

export default Spacer
